import { ILoadingOverlayAngularComp } from 'ag-grid-angular';
import { ILoadingOverlayParams } from 'ag-grid-community';
import { Component } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-documents-loading-overlay',
  templateUrl: './documents-loading-overlay.component.html',
  standalone: true,
  imports: [ MatProgressSpinnerModule ]
})
export class DocumentsLoadingOverlayComponent implements ILoadingOverlayAngularComp {
  params!: ILoadingOverlayParams;

  agInit(params: ILoadingOverlayParams): void {
    this.refresh(params);
  }

  refresh(params: ILoadingOverlayParams): void {
    this.params = params;
  }
}
